import { render } from "./DocumentClassAttributesSubView.vue?vue&type=template&id=64480aa4&scoped=true&ts=true"
import script from "./DocumentClassAttributesSubView.vue?vue&type=script&lang=ts"
export * from "./DocumentClassAttributesSubView.vue?vue&type=script&lang=ts"

import "./DocumentClassAttributesSubView.vue?vue&type=style&index=0&id=64480aa4&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64480aa4"]])

export default __exports__